import '@archetype-themes/scripts/vendors/flickity';
import '@archetype-themes/scripts/config';

class FeaturedCards {
  constructor(container) {
    this.container = container;
    this.gridInner = container.querySelector('.featured-cards-grid__inner');
    this.flickityInstance = null;
    this.mobileBreakpoint = 749;

    if (!this.gridInner) return;

    this.init();
    this.setupResizeHandler();
  }

  init() {
    if (this.shouldInitializeSlider()) {
      this.initSlider();
    }
  }

  shouldInitializeSlider() {
    if (this.container.dataset.mobileLayout !== 'slider') return false;
    return window.innerWidth <= this.mobileBreakpoint;
  }

  initSlider() {
    if (this.flickityInstance) return;

    this.flickityInstance = new Flickity(this.gridInner, {
      cellAlign: 'left',
      contain: false,
      pageDots: true,
      prevNextButtons: false,
      wrapAround: false,
      dragThreshold: 10,
      freeScroll: false,
      groupCells: false,
      rightToLeft: false,
      accessibility: true,
      setGallerySize: true,
      imagesLoaded: true
    });

    this.updatePaginationVisibility();
    this.flickityInstance.on('cellChange', this.updatePaginationVisibility.bind(this));
    this.flickityInstance.on('resize', this.updatePaginationVisibility.bind(this));
  }

  destroySlider() {
    if (!this.flickityInstance) return;

    this.flickityInstance.destroy();
    this.flickityInstance = null;
  }

  setupResizeHandler() {
    let resizeTimeout;

    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        const shouldHaveSlider = this.shouldInitializeSlider();
        const hasSlider = this.flickityInstance !== null;

        if (shouldHaveSlider && !hasSlider) {
          this.initSlider();
        } else if (!shouldHaveSlider && hasSlider) {
          this.destroySlider();
        }
      }, 250);
    });
  }

  onUnload() {
    this.destroySlider();
  }

  updatePaginationVisibility() {
    if (!this.flickityInstance || !this.gridInner) return;

    const slideCount = this.flickityInstance.slides ? this.flickityInstance.slides.length : 0;
    const shouldHideDots = slideCount <= 1;
    const dots = this.gridInner.querySelector('.flickity-page-dots');

    this.gridInner.classList.toggle('has-single-slide', shouldHideDots);

    if (dots) {
      dots.hidden = shouldHideDots;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const featuredCardsContainers = document.querySelectorAll('[data-featured-cards]');

  featuredCardsContainers.forEach((container) => {
    new FeaturedCards(container);
  });
});

if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const container = event.target.querySelector('[data-featured-cards]');
    if (container) {
      new FeaturedCards(container);
    }
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const container = event.target.querySelector('[data-featured-cards]');
    if (container && container.featuredCardsInstance) {
      container.featuredCardsInstance.onUnload();
    }
  });
}

export default FeaturedCards;
